import { useForm } from "@mantine/form";
import { useState, useCallback, useEffect } from "react";
import type { LoginTr } from "./useLoginTranslations";

export interface LoginFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

export function useLoginForm(tr: LoginTr, initialSignUp?: boolean, initialEmail?: string) {
  const [isSignUp, setIsSignUp] = useState(initialSignUp ?? false);

  useEffect(() => {
    if (initialSignUp !== undefined) {
      setIsSignUp(initialSignUp);
    }
  }, [initialSignUp]);
  const [error, setError] = useState("");

  const form = useForm<LoginFormValues>({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",
    },
    validate: {
      email: (value: string) => (/^\S+@\S+$/.test(value) ? null : tr("login.validation.invalidEmail", "Invalid email")),
      password: (value: string) =>
        value.length >= 6 ? null : tr("login.validation.passwordMinLength", "Password must be at least 6 characters"),
    },
  });

  useEffect(() => {
    if (!initialEmail) return;
    form.setFieldValue("email", initialEmail);
  }, [initialEmail]);

  const setIsSignUpWithErrorClear = useCallback((value: boolean) => {
    setIsSignUp(value);
    setError("");
  }, []);

  return {
    form,
    isSignUp,
    setIsSignUp,
    setIsSignUpWithErrorClear,
    error,
    setError,
  };
}
